const sha1 = require('sha1')
const md5 = require('md5')

function checkBrowser (): string {
  const UA: string = navigator.userAgent.toLowerCase()
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(navigator.userAgent.substr(0, 4))) {
    if (/(alipay)/.test(UA)) {
      return 'alipay'
    } else if (/(micromessenger)/.test(UA)) {
      return 'wechat'
    } else if (/(uni-app)/.test(UA) || /(ylkids_android)/.test(UA) || /(ios1.1.0)/.test(UA)) {
      return 'app'
    } else if (/(dingtalk)/.test(UA)) {
      return 'dingding'
    } else {
      return 'mobile'
    }
  } else {
    return 'pc'
  }
}

function formatterCardTime () {
  const date = new Date()
  const o = {
    month: (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1), // 月份
    date: date.getDate() < 10 ? '0' + date.getDate() : date.getDate(), // 日
    hours: date.getHours() < 10 ? '0' + date.getHours() : date.getHours(), // 小时
    minutes: date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(), // 分
    second: date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() // 秒
  }

  return {
    searchTime: o.month + '-' + o.date + ' ' + o.hours + ':' + o.minutes,
    millisecond: new Date().getTime()
  }
} // 记录查询时间

function objKeySort (obj: any): any {
  const newkey = Object.keys(obj).sort()
  const newObj: any = {}
  for (const i of newkey) {
    newObj[i] = obj[i]
  }
  return newObj
}

function getCardServerToken (params: any): string {
  if (Object.keys(params).length > 0) {
    const paramsBak: any = { salt: 'qhyl@#6688' }
    let str = ''
    for (const i of Object.keys(params)) {
      paramsBak[i] = params[i]
    }
    const sortParams: any = objKeySort(paramsBak)
    for (const i of Object.keys(sortParams)) {
      str += `${i}=${sortParams[i]}&`
    }
    str = str.substr(0, str.length - 1)
    str = sha1(str)
    str = md5(str)
    return str
  }
  return ''
}

function getMobileBrand (): string {
  const ua = navigator.userAgent.split('(')[1].split(')')[0]
  let brand = ''
  const phone = [/IPHONE/gi, /huawei/gi, /mi/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi]
  if (phone[0].test(ua)) {
    brand = 'iPhone'
  } else if (phone[1].test(ua)) {
    brand = 'HUAWEI'
  } else if (phone[2].test(ua)) {
    brand = '小米'
  } else if (phone[3].test(ua)) {
    brand = 'vivo'
  } else if (phone[4].test(ua)) {
    brand = 'OPPO'
  } else if (phone[5].test(ua)) {
    brand = 'SAMSUNG'
  } else if (phone[6].test(ua)) {
    brand = 'SONY'
  } else if (phone[7].test(ua)) {
    brand = 'Nokia'
  } else if (phone[8].test(ua)) {
    brand = 'HTC'
  } else if (phone[9].test(ua)) {
    brand = 'ZTE'
  } else if (phone[10].test(ua) || phone[11].test(ua)) {
    brand = 'Lenovo'
  } else {
    brand = '未知型号'
  }
  return brand
}

function getStorage (key: string, type?: string): any {
  // if (type === 'arr' || type === 'obj') {
  //   const str = localStorage.getItem(key) || ''
  //   return JSON.parse(str)
  // } else {
  //   return localStorage.getItem(key)
  // }
  const str = localStorage.getItem(key)
  if (str) {
    if (type === 'arr' || type === 'obj') {
      return JSON.parse(str)
    } else {
      return localStorage.getItem(key)
    }
  } else {
    return null
  }
}

function setStorage (key: string, value: any, type?: string): void {
  if (type === 'arr' || type === 'obj') {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    localStorage.setItem(key, value)
  }
}

function getUrlParam (name: string) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
  const r = window.location.search.substr(1).match(reg) // 匹配目标参数
  if (r != null) return unescape(r[2])
  return null // 返回参数值
}

function getUrlRelativePath () {
  const url = document.location.toString()
  const arrUrl = url.split('//')
  const start = arrUrl[1].indexOf('/')
  let relUrl = arrUrl[1].substring(start)
  if (relUrl.indexOf('?') !== -1) {
    relUrl = relUrl.split('?')[0]
  }
  return relUrl
}// 获取重定向URL

function getNowFormatDate () {
  const date = new Date()
  const seperator1 = '-'
  const year = date.getFullYear()
  let month: string | number = date.getMonth() + 1
  let strDate: string | number = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  const currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}// 获取当前日期

function iosOrAndroid () {
  const U = navigator.userAgent
  const isAndroid = U.indexOf('Android') > -1 || U.indexOf('Linux') > -1 || U.indexOf('Adr') > -1
  const isIOS = !!U.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isAndroid) {
    return 'android'
  } else if (isIOS) {
    return 'ios'
  } else {
    return 'pc'
  }
}

function removeStorage (key: Array<string> | string) {
  if (typeof key === 'string') {
    localStorage.removeItem(key)
  } else {
    for (const item of key) {
      localStorage.removeItem(item)
    }
  }
}

function Today () {
  const newDate = new Date()
  const year = newDate.getFullYear()
  const month = newDate.getMonth() + 1
  const date = newDate.getDate();
  (month >= 1 && month <= 9) ? (month as string | number) = '0' + month : month;
  (date >= 0 && date <= 9) ? (date as string | number) = '0' + date : date

  return `${year}-${month}-${date}`
}

function toDecimal (val: any) {
  const type = Object.prototype.toString.call(val)
  if (type === '[object Undefined]' || type === '[object Null]') return '暂无'
  const value = val.toString()
  if (value.indexOf('.') > 0) {
    const decimal = value.substr(value.indexOf('.') + 1, value.length)
    // const number = value.substr(0, value.indexOf('.'))
    if (decimal.length === 1) {
      return value + '0'
    } else if (decimal.length === 2) {
      return value
    } else if (decimal.length >= 3) {
      const new_value = parseFloat(value).toFixed(3)
      return new_value.substr(0, new_value.length - 1)
    }
  } else {
    return value + '.00'
  }
}// 保留两位小数点

// 字符串转成Time(dateDiff)所需方法
function stringToTime (string: string) {
  const f = string.split(' ', 2)
  const d = (f[0] ? f[0] : '').split('-', 3)
  const t = (f[1] ? f[1] : '').split(':', 3)
  return new Date(
    (parseInt(d[0], 10) as any) || null,
    (parseInt(d[1], 10) || 1) - 1,
    (parseInt(d[2], 10) as any) || null,
    (parseInt(t[0], 10) as any) || null,
    (parseInt(t[1], 10) as any) || null,
    (parseInt(t[2], 10) as any) || null
  ).getTime()
}

function dateDiff (date1: any, date2: any): number {
  const type1 = typeof date1
  const type2 = typeof date2
  if (type1 === 'string') {
    date1 = stringToTime(date1)
  } else if (date1.getTime) {
    date1 = date1.getTime()
  }
  if (type2 === 'string') {
    date2 = stringToTime(date2)
  } else if (date2.getTime) {
    date2 = date2.getTime()
  }
  return (date2 - date1) / 1000 / 60 / 60 / 24 // 除1000是毫秒，不加是秒
}

function imgPreloader (url: any) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      resolve(null)
    }
    image.onerror = (e) => {
      reject(e)
    }
    image.src = url
  })
}

function imgsPreloader (imgs: any) {
  let promiseArr: any[] = []
  imgs.forEach((element: any) => {
    promiseArr.push(imgPreloader(element))
  })
  return Promise.all(promiseArr)
}

export {
  checkBrowser,
  getCardServerToken,
  getMobileBrand,
  getStorage,
  getUrlParam,
  getUrlRelativePath,
  getNowFormatDate,
  iosOrAndroid,
  objKeySort,
  removeStorage,
  setStorage,
  Today,
  toDecimal,
  dateDiff,
  imgsPreloader,
  formatterCardTime
}
